import { render, staticRenderFns } from "./NavUserCenterMessage.vue?vue&type=template&id=163d8f10&scoped=true&"
import script from "./NavUserCenterMessage.vue?vue&type=script&lang=js&"
export * from "./NavUserCenterMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d8f10",
  null
  
)

export default component.exports